import { createFileRoute, Link } from "@tanstack/react-router";
import { Layout } from "@/components/site/Layout";
import {
  ArrowRight,
  ShieldCheck,
  Clock,
  Users,
  Cake,
  Trees,
  Target,
  Mountain,
  Zap,
  Crosshair,
  Building2,
  GraduationCap,
  Plus,
  Phone,
  CalendarCheck,
  FileCheck,
  AlertCircle,
  Sparkles,
  MessageCircle,
  Calculator,
} from "lucide-react";
import { useT } from "@/lib/i18n";
import { openAgentE } from "@/lib/agente-open";

/* ----------------------------- Datos de tarifas ---------------------------- */

const PARTICULARES = [
  { name: "No Limits", detail: "Circuitos + circuito de tirolinas + salto al vacío", price: "45 €", featured: true },
  { name: "Circuitos aventura (3 h) + tirolinas", detail: "Todos los circuitos y el circuito de tirolinas", price: "35 €" },
  { name: "Circuitos aventura (3 h) + salto al vacío", detail: "Todos los circuitos y el salto al vacío", price: "35 €" },
  { name: "Circuitos aventura (3 h)", detail: "Mayores de 8 años", price: "30 €" },
  { name: "Multiaventura", detail: "Circuito en los árboles + escalada en árboles + galería de tiro · mín. 5 participantes", price: "25 €" },
  { name: "Circuito familiar", detail: "De 5 a 8 años · un adulto con el niño", price: "25 €" },
  { name: "1 circuito", detail: "+ de 8 años y adultos", price: "15 €" },
  { name: "Circuito infantil", detail: "De 5 a 8 años · 1 hora", price: "15 €" },
  { name: "Circuito de tirolinas", detail: "Más de 1 km volando entre pinos", price: "10 €" },
  { name: "Salto al vacío", detail: "2 saltos de pura adrenalina", price: "10 €" },
  { name: "Paintball infantil y adultos", detail: "Solo grupos", price: "Consultar" },
  { name: "Lucha de arqueros", detail: "Solo grupos", price: "Consultar" },
  { name: "Gelball", detail: "Solo grupos", price: "Consultar" },
];

const CUMPLES = [
  {
    icon: Trees,
    name: "Aventura en los árboles · Opción 1",
    price: "150 €",
    includes: "1 circuito y tiro con arco",
    duration: "1,5 horas",
    people: "Hasta 10 participantes",
    age: "A partir de 6 años",
    extras: ["Participante extra: 15 €"],
  },
  {
    icon: Trees,
    name: "Aventura en los árboles · Opción 2",
    price: "200 €",
    includes: "Todos los circuitos en los árboles",
    duration: "3 horas",
    people: "Hasta 10 participantes",
    age: "A partir de 9 años",
    extras: ["Participante extra: 20 €"],
  },
  {
    icon: Zap,
    name: "A Bolazos · Gelball",
    price: "150 €",
    includes: "Batalla de gelball con todo el equipo",
    duration: "1 hora",
    people: "Hasta 10 participantes",
    age: "A partir de 6 años",
    extras: ["Participante extra: 15 €"],
  },
  {
    icon: Crosshair,
    name: "A Bolazos · Paintball",
    price: "200 €",
    includes: "Batalla de paintball en campos diseñados",
    duration: "1,5 horas",
    people: "Hasta 15 participantes",
    age: "A partir de 8 años",
    extras: ["Participante extra: 16 €", "1000 bolas extra: 50 €"],
  },
  {
    icon: Target,
    name: "Lucha de Arqueros",
    price: "150 €",
    includes: "Arcos, flechas especiales, máscaras y dianas",
    duration: "1 hora",
    people: "Hasta 10 participantes",
    age: "A partir de 8 años",
    extras: ["Participante extra: 15 €", "30 min adicionales: 5 €/participante"],
  },
  {
    icon: Mountain,
    name: "Escalador Aventurero",
    price: "200 €",
    includes: "1 circuito y escalada en Boulder/Rocódromo",
    duration: "2 horas",
    people: "Hasta 10 participantes",
    age: "A partir de 5 años",
    extras: ["Participante extra: 20 €"],
  },
];

const CUMPLE_EXTRAS = [
  { name: "Escalada en árboles, rocódromo o boulder", price: "5 €/persona" },
  { name: "Circuito de tirolinas", price: "10 €/persona" },
  { name: "Guantes", price: "5 €/persona" },
];

const GRUPOS = [
  { name: "Multiaventura", detail: "1 circuito + escalada en árboles + tiro con arco", prices: ["23 €", "22 €", "21 €", "20 €"] },
  { name: "Aventura", detail: "Todos los circuitos", prices: ["23 €", "22 €", "21 €", "20 €"] },
  { name: "Intrépido", detail: "2 circuitos + escalada en árboles, tiro con arco o salto al vacío", prices: ["25 €", "24 €", "23 €", "22 €"] },
  { name: "Ardilla", detail: "2 circuitos + circuito de tirolinas", prices: ["30 €", "29 €", "28 €", "27 €"] },
  { name: "Extremo", detail: "1 circuito + tirolinas + salto al vacío o escalada en árboles", prices: ["32 €", "31 €", "30 €", "29 €"] },
  { name: "Experto", detail: "Todos los circuitos + circuito de tirolinas", prices: ["33 €", "32 €", "31 €", "30 €"] },
  { name: "Altura y Pintura", detail: "Paintball, archery o gelball + 1 circuito + tirolinas", prices: ["36 €", "35 €", "34 €", "33 €"] },
  { name: "Profesional", detail: "Todos los circuitos + salto al vacío + tirolinas", prices: ["38 €", "37 €", "36 €", "35 €"] },
];

const GRUPOS_TIERS = ["Hasta 25", "+25", "+60", "+100"];

const GRUPOS_SUPLEMENTOS = [
  { name: "Paintball, lucha de arqueros, tirolinas o gelball", price: "+10 €/participante" },
  { name: "Salto al vacío, rocódromo, boulder o pinódromo", price: "+5 €/participante" },
];

const ESCOLARES = [
  {
    icon: FileCheck,
    title: "Resguardo de reserva",
    desc: "Todo centro debe disponer de un resguardo de reserva que recoge los acuerdos entre ambas partes. Los cambios posteriores deben notificarse con antelación para reflejarse en el documento.",
  },
  {
    icon: CalendarCheck,
    title: "Cancelaciones",
    desc: "Las cancelaciones pueden realizarse hasta 24 horas antes de la actividad sin coste alguno.",
  },
  {
    icon: Phone,
    title: "Confirmación final",
    desc: "Entre 2 y 3 días antes de la actividad realizamos una llamada para confirmar los datos. Toda cancelación o aplazamiento posterior conlleva el pago del 100 % de la actividad, salvo fuerza mayor.",
  },
  {
    icon: Users,
    title: "Número de participantes",
    desc: "El número confirmado en la llamada final será el reflejado en el resguardo y la factura. Las bajas de última hora deben justificarse documentalmente (p. ej., parte médico).",
  },
  {
    icon: AlertCircle,
    title: "Cambios no reflejados",
    desc: "Salvo fuerza mayor o imprevistos de última hora, los cambios no reflejados en el resguardo no obligan al centro a atenderlos.",
  },
  {
    icon: ShieldCheck,
    title: "Aceptación de normas",
    desc: "La visita a las instalaciones implica la aceptación de todas las normas del centro.",
  },
];

const ACCESS_RULES = [
  "La entrada a todos los circuitos da acceso a los circuitos que por edad y altura puedan realizarse.",
  "El acceso a los circuitos está condicionado por EDAD Y ALTURA. Ejemplo: si un niño tiene 8 años pero da la altura, puede entrar acompañado de un adulto.",
  "El acceso a 1 circuito sólo está disponible cuando, por ocupación u horario, ya no puede hacerse la modalidad de todos los circuitos.",
  "Los menores de edad han de estar siempre acompañados de un adulto responsable.",
  "El acceso al salto al vacío o al circuito de tirolinas conlleva haber pasado por al menos 1 circuito de aventura en los árboles.",
];

const SECTIONS = [
  { id: "particulares", label: "Particulares", icon: Users },
  { id: "cumples", label: "Cumpleaños", icon: Cake },
  { id: "grupos", label: "Grupos y empresas", icon: Building2 },
  { id: "escolares", label: "Escolares", icon: GraduationCap },
];

export const Route = createFileRoute("/services/paquetes")({
  component: Packages,
  head: () => ({
    meta: [
      { title: "Tarifas — Bosque Suspendido" },
      { name: "description", content: "Tarifas del Bosque Suspendido para particulares, cumpleaños, grupos, empresas y escolares. IVA incluido. Reserva previa obligatoria y gratuita." },
      { property: "og:title", content: "Tarifas — Bosque Suspendido" },
      { property: "og:description", content: "Precios para particulares, cumpleaños, grupos y escolares." },
      { property: "og:url", content: "https://bosque-suspendido.lovable.app/services/paquetes" },
    ],
    links: [{ rel: "canonical", href: "https://bosque-suspendido.lovable.app/services/paquetes" }],
  }),
});

function SectionHeading({ icon: Icon, kicker, title }: { icon: typeof Users; kicker: string; title: string }) {
  return (
    <div className="text-center mb-10">
      <div className="inline-flex items-center gap-2 text-gold">
        <Icon size={18} aria-hidden />
        <span className="text-[10px] tracking-[0.4em] uppercase">{kicker}</span>
      </div>
      <h2 className="font-serif text-3xl md:text-4xl mt-3">{title}</h2>
    </div>
  );
}

function Packages() {
  const { tk } = useT();

  return (
    <Layout>
      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 pt-20 pb-12 text-center">
          <span className="text-[10px] tracking-[0.4em] uppercase text-gold">{tk("packages.kicker", "Tarifas")}</span>
          <h1 className="font-serif text-4xl md:text-6xl mt-4">
            {tk("packages.title.a", "Elige tu ")}
            <em className="not-italic gold-gradient">{tk("packages.title.b", "aventura")}</em>
          </h1>
          <p className="mt-5 text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            {tk("packages.intro", "Precios con IVA incluido (21 %). La reserva previa es obligatoria y gratuita. Particulares, cumpleaños, grupos, empresas y escolares: hay un plan para cada aventurero.")}
          </p>

          {/* Quick nav */}
          <nav className="mt-10 flex flex-wrap justify-center gap-3" aria-label="Secciones de tarifas">
            {SECTIONS.map((s) => (
              <a
                key={s.id}
                href={`#${s.id}`}
                className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-card px-5 py-2.5 text-xs tracking-[0.15em] uppercase font-bold text-foreground/80 hover:bg-gold/10 hover:border-gold transition-colors"
              >
                <s.icon size={14} className="text-gold" aria-hidden />
                {s.label}
              </a>
            ))}
          </nav>

          {/* AgentE callout */}
          <div className="mt-10 max-w-3xl mx-auto rounded-3xl bg-primary text-primary-foreground px-7 py-6 md:px-9 md:py-7 relative overflow-hidden shadow-lg text-left">
            <div className="absolute -top-12 -right-12 h-40 w-40 rounded-full bg-gold/20 blur-2xl" aria-hidden />
            <div className="flex flex-col md:flex-row md:items-center gap-5 md:gap-7">
              <div className="flex items-center gap-4 shrink-0">
                <div className="h-14 w-14 rounded-2xl bg-gold text-accent-foreground flex items-center justify-center shadow-md">
                  <Sparkles size={26} aria-hidden />
                </div>
              </div>
              <div className="flex-1">
                <div className="inline-flex items-center gap-1.5 text-[10px] tracking-[0.3em] uppercase font-bold text-gold-soft">
                  Tu asistente de aventuras
                </div>
                <h2 className="font-serif text-xl md:text-2xl mt-1 text-primary-foreground">
                  ¿Dudas con las tarifas? Pregunta a <em className="not-italic gold-gradient">AgentE</em>
                </h2>
                <p className="mt-2 text-sm text-primary-foreground/80 leading-relaxed">
                  AgentE te ayuda a encontrar las mejores tarifas para tus actividades, calcula el precio de tu grupo al instante y resuelve cualquier duda que tengas.
                </p>
              </div>
              <div className="shrink-0 flex flex-col gap-2">
                <button
                  type="button"
                  onClick={openAgentE}
                  className="inline-flex items-center justify-center gap-2 wood-btn px-6 py-3.5 text-xs tracking-[0.25em] uppercase"
                >
                  <MessageCircle size={14} aria-hidden /> Hablar con AgentE
                </button>
                <span className="inline-flex items-center justify-center gap-1.5 text-[10px] text-primary-foreground/60 tracking-wide">
                  <Calculator size={11} aria-hidden /> Cálculo instantáneo · Gratis · 24/7
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ------------------------------ Particulares ------------------------------ */}
      <section id="particulares" className="scroll-mt-32">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <SectionHeading icon={Users} kicker="Para ti, en pareja o en familia" title="Tarifa Particulares" />

          <div className="max-w-6xl mx-auto space-y-6">
            {/* Featured: No Limits — horizontal banner */}
            <div className="rounded-3xl bg-primary text-primary-foreground p-8 md:px-10 relative overflow-hidden shadow-xl flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
              <div className="absolute -top-10 -right-10 h-44 w-44 rounded-full bg-gold/20 blur-2xl" aria-hidden />
              <div className="flex-1 min-w-0">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-gold text-accent-foreground px-3 py-1 text-[10px] tracking-[0.25em] uppercase font-bold">
                  <Zap size={12} aria-hidden /> Lo más completo
                </span>
                <h3 className="font-serif text-3xl mt-4 text-primary-foreground">No Limits</h3>
                <p className="mt-2 text-primary-foreground/80 leading-relaxed text-sm max-w-xl">
                  Todos los circuitos de aventura + circuito de tirolinas + salto al vacío. La experiencia total del bosque, sin límites.
                </p>
              </div>
              <div className="shrink-0 flex flex-col items-start md:items-end gap-4">
                <div className="flex items-end gap-2">
                  <span className="font-serif text-6xl leading-none">45</span>
                  <span className="font-serif text-2xl mb-1">€</span>
                  <span className="text-primary-foreground/70 text-xs mb-2">/ persona</span>
                </div>
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center gap-2 wood-btn px-8 py-3.5 text-xs tracking-[0.3em] uppercase"
                >
                  Reservar <ArrowRight size={12} />
                </Link>
              </div>
            </div>

            {/* Price board — two columns on desktop */}
            <div className="rounded-3xl border border-gold/30 bg-card overflow-hidden shadow-md">
              {(() => {
                const items = PARTICULARES.filter((p) => !p.featured);
                const mid = Math.ceil(items.length / 2);
                const cols = [items.slice(0, mid), items.slice(mid)];
                return (
                  <div className="lg:grid lg:grid-cols-2">
                    {cols.map((col, i) => (
                      <ul
                        key={i}
                        className={
                          i === 0
                            ? "divide-y divide-gold/15 lg:border-r lg:border-gold/15"
                            : "divide-y divide-gold/15 border-t border-gold/15 lg:border-t-0"
                        }
                      >
                        {col.map((p) => (
                          <li key={p.name} className="flex items-center justify-between gap-4 px-6 py-4 hover:bg-gold/5 transition-colors">
                            <div>
                              <div className="font-bold text-sm">{p.name}</div>
                              <div className="text-xs text-muted-foreground mt-0.5">{p.detail}</div>
                            </div>
                            <div
                              className={
                                p.price === "Consultar"
                                  ? "shrink-0 text-[10px] tracking-[0.2em] uppercase font-bold text-gold border border-gold/40 rounded-full px-3 py-1.5"
                                  : "shrink-0 font-serif text-2xl text-primary"
                              }
                            >
                              {p.price}
                            </div>
                          </li>
                        ))}
                      </ul>
                    ))}
                  </div>
                );
              })()}
            </div>
          </div>
        </div>
      </section>

      {/* ------------------------------- Cumpleaños ------------------------------- */}
      <section id="cumples" className="scroll-mt-32 bg-card/60 border-y border-gold/15">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <SectionHeading icon={Cake} kicker="El cumple que no olvidarán" title="Paquetes de Cumpleaños" />

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {CUMPLES.map((c) => (
              <div
                key={c.name}
                className="group rounded-3xl border border-gold/30 bg-background p-7 flex flex-col shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="h-12 w-12 rounded-2xl bg-gold/15 text-gold flex items-center justify-center">
                    <c.icon size={22} aria-hidden />
                  </div>
                  <div className="text-right">
                    <div className="font-serif text-3xl text-primary leading-none">{c.price}</div>
                    <div className="text-[10px] text-muted-foreground uppercase tracking-wider mt-1">por grupo</div>
                  </div>
                </div>
                <h3 className="font-serif text-xl mt-5 leading-snug">{c.name}</h3>
                <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{c.includes}</p>
                <ul className="mt-5 space-y-2 text-xs text-foreground/80">
                  <li className="flex items-center gap-2"><Clock size={13} className="text-gold shrink-0" aria-hidden /> {c.duration} aprox.</li>
                  <li className="flex items-center gap-2"><Users size={13} className="text-gold shrink-0" aria-hidden /> {c.people}</li>
                  <li className="flex items-center gap-2"><Cake size={13} className="text-gold shrink-0" aria-hidden /> {c.age}</li>
                </ul>
                <div className="mt-5 pt-4 border-t border-gold/15 space-y-1.5">
                  {c.extras.map((e) => (
                    <div key={e} className="flex items-center gap-2 text-xs text-muted-foreground">
                      <Plus size={12} className="text-gold shrink-0" aria-hidden /> {e}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Extras */}
          <div className="max-w-4xl mx-auto mt-10 rounded-3xl bg-primary text-primary-foreground px-8 py-7">
            <div className="flex flex-col md:flex-row md:items-center gap-6">
              <h3 className="font-serif text-2xl shrink-0 text-primary-foreground">Completa tu aventura</h3>
              <div className="flex flex-wrap gap-3">
                {CUMPLE_EXTRAS.map((e) => (
                  <span key={e.name} className="inline-flex items-center gap-2 rounded-full bg-primary-foreground/10 border border-primary-foreground/20 px-4 py-2 text-xs">
                    {e.name} · <strong className="text-gold-soft">{e.price}</strong>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --------------------------- Grupos y empresas --------------------------- */}
      <section id="grupos" className="scroll-mt-32">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <SectionHeading icon={Building2} kicker="Cuantos más, mejor precio" title="Grupos y Empresas" />

          <div className="max-w-5xl mx-auto rounded-3xl border border-gold/30 bg-card overflow-hidden shadow-md">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-primary text-primary-foreground">
                    <th className="text-left px-6 py-4 font-serif text-base">Paquete</th>
                    {GRUPOS_TIERS.map((t) => (
                      <th key={t} className="px-4 py-4 text-center whitespace-nowrap">
                        <span className="block text-[10px] uppercase tracking-[0.2em] text-primary-foreground/70">pers.</span>
                        <span className="font-serif text-base">{t}</span>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gold/15">
                  {GRUPOS.map((g) => (
                    <tr key={g.name} className="hover:bg-gold/5 transition-colors">
                      <td className="px-6 py-4">
                        <div className="font-bold uppercase tracking-wide text-xs text-primary">{g.name}</div>
                        <div className="text-xs text-muted-foreground mt-1 leading-relaxed">{g.detail}</div>
                      </td>
                      {g.prices.map((p, i) => (
                        <td key={i} className={`px-4 py-4 text-center font-serif text-lg whitespace-nowrap ${i === g.prices.length - 1 ? "text-gold-deep font-bold" : "text-foreground/80"}`}>
                          {p}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="max-w-5xl mx-auto mt-6 grid sm:grid-cols-2 gap-4">
            {GRUPOS_SUPLEMENTOS.map((s) => (
              <div key={s.name} className="rounded-2xl border border-gold/30 bg-card px-6 py-4 flex items-center justify-between gap-4">
                <div className="flex items-center gap-3 text-sm">
                  <Plus size={16} className="text-gold shrink-0" aria-hidden />
                  <span className="text-foreground/85">{s.name}</span>
                </div>
                <span className="font-serif text-lg text-primary whitespace-nowrap">{s.price}</span>
              </div>
            ))}
          </div>
          <p className="text-center text-xs text-muted-foreground mt-6 tracking-wide">IVA incluido (21 %) en todos los precios.</p>
        </div>
      </section>

      {/* -------------------------------- Escolares ------------------------------- */}
      <section id="escolares" className="scroll-mt-32 bg-card/60 border-y border-gold/15">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <SectionHeading icon={GraduationCap} kicker="Centros educativos" title="Escolares" />
          <p className="text-center text-muted-foreground max-w-2xl mx-auto -mt-4 mb-10 leading-relaxed text-sm">
            Sea la edad que sea, tenemos el programa para tu clase: recibimos a más de 500 escolares simultáneamente. Estas son nuestras condiciones de reserva.
          </p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
            {ESCOLARES.map((e) => (
              <div key={e.title} className="rounded-2xl border border-gold/25 bg-background p-6">
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-xl bg-gold/15 text-gold flex items-center justify-center shrink-0">
                    <e.icon size={18} aria-hidden />
                  </div>
                  <h3 className="font-serif text-lg leading-tight">{e.title}</h3>
                </div>
                <p className="text-sm text-muted-foreground mt-4 leading-relaxed">{e.desc}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <Link to="/contact" className="inline-flex items-center gap-2 wood-btn px-8 py-4 text-xs tracking-[0.3em] uppercase">
              Solicitar programa escolar <ArrowRight size={12} />
            </Link>
          </div>
        </div>
      </section>

      {/* ------------------------------ Normas de acceso --------------------------- */}
      <section>
        <div className="max-w-4xl mx-auto px-6 py-16">
          <div className="flex items-center gap-3 mb-6">
            <ShieldCheck className="text-gold" size={22} />
            <h2 className="font-serif text-2xl">{tk("packages.rules.title", "Normas de acceso")}</h2>
          </div>
          <ul className="space-y-3">
            {ACCESS_RULES.map((rule) => (
              <li key={rule} className="flex gap-3 text-foreground/85 text-sm leading-relaxed">
                <span className="mt-2 h-1.5 w-1.5 rounded-full bg-gold shrink-0" aria-hidden />
                <span>{rule}</span>
              </li>
            ))}
          </ul>
          <p className="mt-8 text-xs tracking-[0.3em] uppercase text-gold text-center">
            {tk("packages.rules.note", "La reserva previa es obligatoria y gratuita")}
          </p>
        </div>
      </section>
    </Layout>
  );
}
